import type { ChatMessage } from "~/lib/hooks/useAIChat";

interface MessageProps {
  message: ChatMessage;
}

export function Message({ message }: MessageProps) {
  const isUser = message.role === "user";
  return (
    <div
      className={[
        "flex w-full",
        isUser ? "justify-end" : "justify-start",
      ].join(" ")}
      role={isUser ? undefined : "status"}
      aria-live={message.streaming ? "polite" : undefined}
    >
      <div
        className={[
          "max-w-[85%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed whitespace-pre-wrap break-words sm:text-[15px]",
          isUser
            ? "rounded-br-sm bg-jg-ai/15 text-jg-fg ring-1 ring-jg-ai/30"
            : "rounded-bl-sm bg-jg-bg-soft/70 text-jg-fg ring-1 ring-jg-border/60",
        ].join(" ")}
      >
        {message.content}
        {message.streaming && (
          <span
            aria-hidden="true"
            className="ml-0.5 inline-block h-3.5 w-1.5 translate-y-0.5 animate-pulse bg-jg-ai/80"
          />
        )}
      </div>
    </div>
  );
}
